import { TranslationKey } from '@Localization';
import { QuestionType } from '../../../annotation/question.model';
import { ImageSetType } from '../images/projectDetailsImages.model';

export interface IProjectToolStatisticsDto {
  projectId: string;
  generatedAt: string;
  headers: IToolStatisticHeaders;
  allAnnotationTypeStatistics: IAnnotationStatusStatisticsDto[];
  allQuestionsStatistics: IAnnotationStatusStatisticsDto[];
  allImageSetsStatistics: IAnnotationStatusStatisticsDto[];
  annotationTypesStatistics: IToolStatisticsDto[];
  questionStatistics: IToolStatisticsDto[];
  imageSetsStatistics: IToolStatisticsDto[];
}

interface IToolStatisticHeaders {
  annotationToolsHeaders: IToolStatisticHeader[];
  annotationQuestionHeaders: IToolStatisticHeader[];
  imageSetsHeaders: IImageSetHeader[];
  isUpToDate: boolean;
}

interface IToolStatisticHeader {
  id: string;
  name: string;
  type: string;
  usageCount: number;
  order: number;
}

interface IImageSetHeader {
  id: string;
  name: ImageSetType;
  count: number;
}

export interface IToolStatisticsDto {
  annotationStatusStatistics: IAnnotationStatusStatisticsDto;
  answerStatistics: IAnswerStatisticDto[];
}

export interface IAnnotationStatusStatisticsDto {
  name: TranslationKey;
  id: string;
  toReview: number;
  accepted: number;
  rejected: number;
}

export interface IAnswerStatisticDto {
  text: string;
  id: string;
  answers: IQuestionAnswerStatisticDto[];
  order: number;
  questionType: QuestionType;
}

interface IQuestionAnswerStatisticDto {
  text: string;
  id: string;
  order: number;
  annotated: number;
  approved: number;
  rejected: number;
}

export interface IStatisticsListItem {
  id: string;
  date: string;
  markedObjects: number;
  answeredAttributes: number;
  answeredQuestions: number;
  imagesAnnotated: number;
  annotationDuration: string;
  annotatingUsersCount: number;
  imagesReviewed: number;
  reviewDuration: string;
  reviewersCount: number;
  cumulativeAnnotatedImages: number;
  cumulativeReviewedImages: number;
  averageObjectsPerImage: number;
}

export enum ToolStatisticsViewMode {
  NONE,
  All_TOOLS,
  ALL_QUESTIONS,
  TOOL,
  QUESTION,
  ALL_IMAGE_SETS,
  IMAGE_SET,
}
